import { useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { setBookingStep } from '@/store/booking/booking.slice';
import { useRouter } from 'next/router';
import { pathsOrder } from '@/config/estepperConfig';
import { useEffect } from 'react';

export default function useStepper() {
  const [breadcrumbFlow, setBreadcrumbFlow] = useState([]);

  const paths = useSelector((state) => state.paths, shallowEqual);

  const router = useRouter();

  const dispatch = useDispatch();

  const getFlow = () =>
    pathsOrder
      .map((path) => {
        return paths[path];
      })
      .filter((path) => path.available);

  const [stepperFlow, setStepperFlow] = useState(getFlow());
  const getBreadcrumbFlow = () => {
    const flow = getFlow();
    const length = flow.length;
    return flow.slice(1, length - 1);
  };

  const getStep = (index) => stepperFlow[index];

  const currentStep = () => {
    const currentPath =
      router.pathname === '/'
        ? 'HOME'
        : router.pathname.replace('/', '').toUpperCase();

    let currentIndex = stepperFlow.findIndex(
      (step) => currentPath === step.name,
    );

    return { currentIndex, currentPath };
  };

  const changeStep = (stepIndex) => {
    const { path, name } = getStep(stepIndex);
    router.push(path);
    if (name !== 'HOME' && name !== 'SUCCESS') dispatch(setBookingStep(name));
  };

  const nextStep = () => {
    const { currentIndex, currentPath } = currentStep();
    if (currentPath !== 'SUCCESS') changeStep(currentIndex + 1);
  };

  const prevStep = () => {
    const { currentIndex, currentPath } = currentStep();
    if (currentPath !== 'HOME') changeStep(currentIndex - 1);
  };

  // PATH in uppercase pe: PAYMENT
  const jumpTo = (path, query) => {
    const index = stepperFlow.findIndex((step) => step.name === path);
    if (index >= 0) {
      changeStep(index);
      return;
    }

    if (paths[path]) {
      router.push(`${paths[path].path}${query ? query : ''}`);
      if (path !== 'HOME' && path !== 'SUCCESS') {
        dispatch(setBookingStep(path));
      }
    }
  };

  const success = async () => {
    if (router.pathname === '/success') {
      dispatch(setBookingStep(paths.SUCCESS.name));
    }
  };

  useEffect(() => {
    setStepperFlow(getFlow());
    setBreadcrumbFlow(getBreadcrumbFlow());
  }, [paths]);

  return {
    stepperFlow,
    breadcrumbFlow,
    nextStep,
    prevStep,
    jumpTo,
    success,
  };
}
